import { render } from "./mapping-wilayah-sales-person.vue?vue&type=template&id=6cc53250"
import script from "./mapping-wilayah-sales-person.vue?vue&type=script&lang=js"
export * from "./mapping-wilayah-sales-person.vue?vue&type=script&lang=js"
script.render = render

export default script